import React, { useEffect, useState } from "react";
import { Image } from "@react-pdf/renderer";
import { generateBarcodeBase64 } from "../../../../utils/barcodeBase64";

const PDFBarcode = ({ value }) => {

  const [barcode, setBarcode] = useState(null);

  useEffect(() => {
    const loadBarcode = async () => {
      const img = await generateBarcodeBase64(value);
      setBarcode(img);
    };

    loadBarcode();
  }, [value]);

  if (!barcode) return null;

  return (
    <Image
      src={barcode}
      style={{
        width: 250,
        height: 80,
        alignContent: "center"
      }}
    />
  );
};

export default PDFBarcode;